var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChatComment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C9EA7",
    fillRule: "nonzero",
    d: "M6.188 10.53h5.625c.31 0 .562.254.562.568a.566.566 0 0 1-.563.568H6.189a.566.566 0 0 1-.563-.568c0-.314.252-.569.563-.569zM5.063 7.117h7.875c.31 0 .562.255.562.568a.566.566 0 0 1-.563.569H5.064a.566.566 0 0 1-.563-.569c0-.313.252-.568.563-.568zM9 .864c4.97 0 9 3.564 9 7.96 0 2.512-1.32 4.749-3.375 6.207v4.026l-3.943-2.418c-.545.091-1.107.144-1.682.144-4.97 0-9-3.563-9-7.96C0 4.429 4.03.865 9 .865zm0 14.782a9.01 9.01 0 0 0 1.901-.209l2.649 1.61-.036-2.638c2.03-1.234 3.361-3.274 3.361-5.585C16.875 5.056 13.349 2 9 2c-4.35 0-7.875 3.055-7.875 6.823 0 3.767 3.526 6.822 7.875 6.822z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChatComment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat-comment.a2bec5e6.svg";
export { ForwardRef as ReactComponent };